import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check } from 'lucide-react';
const benefits = ['Pay per approved milestone', 'No hourly billing', 'Clear scope upfront', 'Reduced delivery risk', 'You own the IP once paid', 'Weekly progress updates'];
export function WhyThisWorks() {
  return <section className="w-full bg-neutral-50 py-24 md:py-32" data-id="element-84">
      <div className="max-w-7xl mx-auto px-6" data-id="element-85">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-86">
          <FadeIn data-id="element-87">
            <h2 className="text-3xl md:text-5xl font-semibold tracking-tight text-neutral-900 mb-8 leading-tight" data-id="element-88">
              Why this model works better for your business
            </h2>
            <p className="text-xl text-neutral-600 leading-relaxed mb-8" data-id="element-89">
              Traditional agencies bill for time, incentivizing slower work. We
              bill for outcomes, incentivizing efficiency and quality.
            </p>
          </FadeIn>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-6" data-id="element-90">
            {benefits.map((benefit, index) => <FadeIn key={index} delay={0.2 + index * 0.05} data-id="element-91">
                <div className="flex items-start" data-id="element-92">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-neutral-900 flex items-center justify-center mt-1" data-id="element-93">
                    <Check className="w-3.5 h-3.5 text-white" data-id="element-94" />
                  </div>
                  <span className="ml-4 text-lg text-neutral-800 font-medium" data-id="element-95">
                    {benefit}
                  </span>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}